module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "customers-menu"
    }
  }, [_c('md-tabs', {
    attrs: {
      "md-active-tab": _vm.activeTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "tab-customers",
      "md-label": "Клиенты",
      "to": {
        name: 'Customers'
      }
    }
  }), _c('md-tab', {
    attrs: {
      "id": "tab-groups",
      "md-label": "Группы",
      "to": {
        name: 'CustomerGroups'
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-266a7d2e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/customers/views/menu.vue
// module id = 1075
// module chunks = 0